import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  TEACHER_CATEGORY_BADGE_CLASS,
  TEACHER_CATEGORY_LABELS,
} from '../constants/teacherSubmission.constants';
import type { TeacherCategory } from '../types/teacherSubmission.types';

interface TeacherCategoryBadgeProps {
  category: TeacherCategory;
  className?: string;
}

export function TeacherCategoryBadge({ category, className }: TeacherCategoryBadgeProps) {
  return (
    <Badge className={cn('font-medium', TEACHER_CATEGORY_BADGE_CLASS[category], className)}>
      {TEACHER_CATEGORY_LABELS[category]}
    </Badge>
  );
}
